import _ from 'lodash';
import NamedDto from 'modules/base/dto/NamedDto';

export default class EdaTypeDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.taskKey = null;
	}

	/**
	 * @typedef {Object} _EdaTypeDtoProps
	 * @property {string} taskKey
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _EdaTypeDtoProps} EdaTypeDtoProps
	 */
	/**
	 *
	 * @param {EdaTypeDtoProps} props
	 * @returns {EdaTypeDto}
	 */
	setup(props) {
		super.setup(props);
		this.taskKey = props.taskKey;
		return this;
	}
}
